import React from "react";
import MainDashboard from "views/admin/default";
import Profile from "views/admin/profile/Profile";
import Affiliate from "components/Affiliate/Affiliate";
import { Telegram } from "components/Telegram/Telegram";
import Billing from "views/admin/billing/Billing";
import Charts from "views/admin/charts";
import SignIn from "views/auth/SignIn";
import SignUp from "views/auth/SignUp";

import {
  MdHome,
  MdOutlineShoppingCart,
  MdBarChart,
  MdPerson,
  MdCreditCard,
  MdShowChart
} from "react-icons/md";

const routes = [
  {
    name: "Main Dashboard",
    layout: "/dashboard",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
  },
  // {
  //   name: "Affiliate",
  //   layout: "/dashboard",
  //   path: "affiliate",
  //   icon: <MdOutlineShoppingCart className="h-6 w-6" />,
  //   component: <Affiliate />,
  //   secondary: true,
  // },
  {
    name: "Charts",
    layout: "/dashboard",
    path: "charts",
    icon: <MdShowChart className="h-6 w-6" />,
    component: <Charts />,
  },
  {
    name: "Telegram",
    layout: "/dashboard",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "telegram",
    component: <Telegram />,
  },
  {
    name: "Profile",
    layout: "/dashboard",
    path: "profile",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />,
  },
  {
    name: "Billing",
    layout: "/dashboard",
    path: "billing",
    icon: <MdCreditCard className="h-6 w-6" />,
    component: <Billing />,
  },
];
export default routes;
